import React from 'react';
import { MapPin } from 'lucide-react';
import { SheetBranding } from './types';
import { PropertySheetBrandHeader } from './PropertySheetBrandHeader';

interface PropertySheetHeaderProps {
  operationType: string;
  propertyType: string;
  title: string;
  address: string;
  referenceCode: string;
  branding: SheetBranding;
}

export const PropertySheetHeader: React.FC<PropertySheetHeaderProps> = ({
  operationType,
  propertyType,
  title,
  address,
  referenceCode,
  branding,
}) => {
  return (
    <header className="w-full mb-5">
      {/* Top bar: Operation pill + Ficha subtitle & Dynamic Brand/Broker */}
      <div className="flex items-center justify-between gap-4 pb-3 border-b border-slate-100">
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-[#0a2540] text-white text-[11px] font-extrabold tracking-wider uppercase shadow-xs">
            {operationType} • {propertyType}
          </span>
          <span className="text-[11px] font-bold text-slate-400 uppercase tracking-widest">
            Ficha Técnica Inmobiliaria
          </span>
        </div>
        <PropertySheetBrandHeader branding={branding} />
      </div>

      {/* Title & Reference Box */}
      <div className="mt-2.5 flex items-end justify-between gap-3">
        <div className="flex-1 min-w-0 pr-2">
          <h1 className="text-2xl font-bold text-[#0a2540] leading-normal pb-0.5 truncate">
            {title}
          </h1>
          <div className="flex items-center gap-1.5 mt-0.5 text-xs text-slate-600 font-medium">
            <MapPin className="w-3.5 h-3.5 text-[#d97706] flex-shrink-0" />
            <span className="leading-normal truncate">{address}</span>
          </div>
        </div>

        {/* Reference Code Box */}
        <div className="flex-shrink-0 bg-slate-50 border border-slate-200/90 rounded-xl px-3 py-1 text-right shadow-2xs">
          <div className="text-[9px] font-bold text-slate-400 uppercase leading-normal">
            Código Ref.
          </div>
          <div className="text-[13px] font-extrabold text-[#0a2540] font-mono leading-normal">
            {referenceCode}
          </div>
        </div>
      </div>
    </header>
  );
};
